module.exports = __webpack_public_path__ + "img/findwords-card.6c6390d5.jpg";